import { Redirect } from 'react-router-dom';
import axios from 'axios';
import React, { useEffect, useMemo, useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import loadingIcon from '../../../Assets/loading.gif';
import { Upload as UploadIcon } from '@mui/icons-material';

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // padding: "20px",
  borderWidth: 1.5,
  borderRadius: 2,
  borderColor: 'rgb(221 221 221 / 75%)',
  borderStyle: 'dashed',
  color: '#fff',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  borderRadius: '9px',
  backgroundColor: '#090213',
  fontSize: '14px',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
  minHeight: '45px',
};

const fullScreenStyle = {
  height: '90vh',
  width: '90vw',
  margin: '20px 20px',
};
const activeStyle = {
  borderColor: '#ffd446',
};

const acceptStyle = {
  borderColor: '#ffd446',
};

const rejectStyle = {
  borderColor: '#ffd446',
};

function Upload(props) {
  const [progress, setProgress] = useState('');
  const [redirectTo, setRedirectTo] = useState('');
  const [fullScreen, setFullScreen] = useState(
    props.location && props.location.pathname === '/add/file' ? true : false
  );

  const onDrop = useCallback((acceptedFiles) => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + '/api/upload')
      .then((res) => {
        const preSignedUrl = res.data;

        axios
          .put(preSignedUrl, acceptedFiles[0], {
            onUploadProgress: (progressEvent) => {
              const progressPercentage = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );

              if (progressPercentage === 100) {
                setProgress('Parsing...');
              } else {
                setProgress(progressPercentage + '%');
              }
            },
            headers: {
              Accept: '*/*',
              'Content-Type': 'application/pdf',
            },
          })
          .then((res) => {
            // POST to /api/upload
            axios
              .post(process.env.REACT_APP_BACKEND_URL + '/api/upload', {
                article_url: preSignedUrl.split('?')[0],
              })
              .then((res) => {
                setRedirectTo(
                  `/add/text?type=pdf&title=${encodeURIComponent(
                    acceptedFiles[0].path
                  )}&text=${encodeURIComponent(
                    res.data.A
                  )}&backupText=${encodeURIComponent(res.data.B)}`
                );
              })
              .catch((err) => {
                setProgress('Error');
              });
          })
          .catch((err) => {
            setProgress('Error');
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ 
    maxFiles: 1, 
    onDrop });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(fullScreen ? fullScreenStyle : {}),
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
    // console.log(acceptedFiles)
  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }
  // files.length === 1
  return (
    <section
      className="container clickable"
      style={{ width: '100%', height: '100%' }}
    >
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <p>
          {files.length === 1 ? (
            <div
              style={{
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <img
                src={loadingIcon}
                style={{ height: '25px', marginRight: '5px' }}
                alt="loading..."
              />
              {progress && progress}
            </div>
          ) : fullScreen ? (
            <div style={{ textAlign: 'center', fontSize: '20px' }}>
              <div>Drag and drop a PDF file</div>
              <div>or click here to browse</div>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <UploadIcon style={{ fontSize: '20px' }} />
              Upload File
            </div>
          )}
        </p>
      </div>
    </section>
  );
}

export default Upload;
